import { MAX_TEXT_OPTION_LOOKUP_IDS } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

/**
 * id 로 폰트 이름 찾기(productManagement.fonts.listByIds, 결정 D12) — 견적 사본의 fontId 를 이름으로 보여 준다.
 * 지운 폰트도 deleted 로 돌려준다. id 가 없으면 묻지 않고, 계약 상한을 넘는 id 는 앞부분만 묻는다(나머지는 화면이 id 로 보여 준다).
 */
export const useFontsByIdsQuery = (ids: readonly string[]) => {
  const lookupIds = ids.slice(0, MAX_TEXT_OPTION_LOOKUP_IDS);
  return trpc.productManagement.fonts.listByIds.useQuery(
    { ids: lookupIds },
    { enabled: lookupIds.length > 0 },
  );
};
